import { useEffect, useRef } from 'react'
import { GrFormClose } from 'react-icons/gr'
import { GoalData, toModalData } from '../../data'
import ModalItem from '../ModalItem'
import styles from './Modal.module.css'

interface ModalProps {
    data: GoalData | undefined
    showModal: boolean
    close: () => void
}

// export const Modal = React.forwardRef<HTMLDivElement, ModalProps>(
export default function Modal({ data, showModal, close }: ModalProps) {
    const modalRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (data != undefined) {
            document.addEventListener('click', handleOutsideClick, false)
        }
    }, [showModal])

    function handleOutsideClick(e: Event) {
        // if click is outside of modald
        if (!modalRef?.current?.contains(e.target as Node)) {
            closeModal()
        }
    }

    function closeModal() {
        document.removeEventListener('click', handleOutsideClick, false)
        close()
    }

    return (
        <div className={`${styles.modalContainer} ${!showModal ? styles.off : ''}`}>
            <div ref={modalRef} className={styles.modal}>
                <div className={styles.closeButton} onClick={closeModal}>
                    <GrFormClose size={30} />
                </div>
                <div className={styles.content}>
                    {data &&
                        toModalData(data).items.map((data, index) => (
                            <ModalItem key={index} isHeader={index === 0} data={data} />
                        ))}
                </div>
            </div>
        </div>
    )
}
